import React from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useMediaQuery, useTheme } from '@mui/material'
import useIsTouchDevice from '../hooks/useIsTouchDevise'


const CustomToaster: React.FC = () => {
  const theme = useTheme()
  const lessThanSmall = useMediaQuery(theme.breakpoints.down('sm'))
  const isTouchDevice = useIsTouchDevice()

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const cssVariables = {
    '--toastify-icon-color-error': theme.palette.custom.attentionRed,
    '--toastify-color-progress-error': theme.palette.custom.redGradient,
    '--toastify-icon-color-info': theme.palette.custom.solidBeauty,
    '--toastify-color-progress-info': theme.palette.custom.beautifulGradient
  } as React.CSSProperties

  const toastPosition = (isTouchDevice && lessThanSmall) ? 'bottom-center' : 'bottom-right'


  return (
    <ToastContainer
      position={toastPosition}
      autoClose={1600}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover
      theme="light"
      style={cssVariables}
    />
  )
}

export default CustomToaster
